import {
    Box, Grid, List
} from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "underscore";
import NotFound from "../../assets/images/NotFound.svg";
import { IsNullOrEmpty } from "../../helpers/utility";
import { fetchPaymentConfigRequest } from "../../store/shopping/shopping.actions";
import {
    getPrivateLoungesRequest,
    getPrivateLoungeUserSuccess
} from "../../store/user/privatelounge/privatelounge.actions";
import { getPrivateLounges } from "../../store/user/privatelounge/privatelounge.selector";
import {
    fetchOtherUserProfileRequest,
    fetchOtherUserProfileSuccess,
    fetchSubscriberListRequest
} from "../../store/user/user.actions";
import {
    getImage,
    getSearchedUsers,
    getSubscriberList
} from "../../store/user/user.selector";

export default function ProfileSubscriber() {
    const dispatch = useDispatch();
    const history = useNavigate();
    const [searchText, setSearchText] = useState("");

    const { subscriberList, privateLounges, allUsers } = useSelector(
        (state) => {
            return {
                subscriberList: getSubscriberList(state),
                isLoading: state.UserReducer.isLoading,
                privateLounges: getPrivateLounges(state),
                allUsers: getSearchedUsers(state),
            };
        }
    );

    useEffect(() => {
        dispatch(fetchSubscriberListRequest());
        dispatch(getPrivateLoungesRequest());
    }, []);

    let searchedUsers = subscriberList;
    if (!IsNullOrEmpty(searchText)) {
        searchedUsers = searchedUsers.filter((x) => {
            return (
                x.subscriber.fullName
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    return (
        <Grid item sm={12} xs={12}>
            <div className="relative mx-auto w-full md:max-w-[294px] bg-white rounded-full">
                <input
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search user"
                    type="search"
                    className="peer duration-300 ease-linear cursor-pointer relative z-[1] w-full h-11 md:w-[320px] rounded-full lg:valid:w-full border border-black-10 bg-transparent pl-11 md:pl-12 outline-none focus:cursor-text focus:border-orange-color focus:pl-11 focus:pr-4 placeholder:hidden"
                    id="search-input"
                />

                <svg
                    width="16"
                    height="16"
                    className="absolute inset-y-0 my-auto h-8 w-12 px-3 sm:px-3.5"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                        fill="black"
                        fillOpacity="0.5"
                    />
                </svg>
            </div>

            <List>
                {searchedUsers &&
                    searchedUsers.map((item) => {
                        let curUser = _.find(
                            allUsers,
                            (x) =>
                                item.subscriber && x._id === item.subscriber._id
                        );
                        let lounge = _.find(
                            privateLounges,
                            (x) => x.user._id === item.subscriber._id
                        );
                        let bill = "";

                        if (curUser.isSubscribe && lounge) {
                            if (
                                curUser.subscription.billingPeriod === "monthly"
                            ) {
                                bill =
                                    lounge.currencySubscription +
                                    " " +
                                    lounge.monthlySubscription;
                            } else {
                                bill =
                                    lounge.currencySubscription +
                                    " " +
                                    lounge.annuallySubscription;
                            }
                        }

                        return (
                            <div className="flex items-center justify-between py-2">
                                <div
                                    className="flex items-center"
                                    onClick={() => {
                                        dispatch(
                                            fetchOtherUserProfileRequest(
                                                item.subscriber._id,
                                                history
                                            )
                                        );
                                    }}
                                >
                                    <img
                                        src={getImage(item.subscriber.avatar)}
                                        alt=""
                                        className="w-[64px] h-[64px] rounded-full mr-3"
                                    />
                                    <div className="">
                                        <h4 className="text-md font-medium text-black-100 mb-0.5 capitalize whitespace-nowrap">
                                            {item.subscriber.fullName}
                                        </h4>
                                        <p className="text-black-50">
                                            {"Followed " +
                                                moment(
                                                    item.dateUpdated
                                                ).fromNow()}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between">
                                    <button
                                        disabled={!lounge}
                                        onClick={(e) => {
                                            if (
                                                !curUser.isSubscribe &&
                                                lounge
                                            ) {
                                                e.stopPropagation();
                                                dispatch(
                                                    fetchPaymentConfigRequest()
                                                );
                                                dispatch(
                                                    fetchOtherUserProfileSuccess(
                                                        {
                                                            data: item.subscriber,
                                                        }
                                                    )
                                                );
                                                dispatch(
                                                    getPrivateLoungeUserSuccess(
                                                        {
                                                            data: lounge,
                                                        }
                                                    )
                                                );
                                                history.push(
                                                    "/page/subscription_payment"
                                                );
                                            }
                                        }}
                                        className={`py-[7px] w-[170px] ${
                                            curUser && curUser.isSubscribe
                                                ? "text-black-50"
                                                : "bg-orange-color text-white"
                                        } rounded-lg border border-black-10 w-full text-sm font-bold  capitalize`}
                                    >
                                        {curUser && curUser.isSubscribe
                                            ? "Subscribed / " + bill
                                            : lounge
                                            ? "Subscribe / " +
                                              lounge.currencySubscription +
                                              " " +
                                              lounge.monthlySubscription
                                            : "Fees not set"}
                                    </button>
                                </div>
                            </div>
                        );
                    })}
            </List>
            {searchedUsers && searchedUsers.length === 0 ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    className="mt-4"
                    width="100%"
                >
                    <img
                        src={NotFound}
                        alt="icon"
                        className="img-responsive max-h-[200px]"
                    />
                </Box>
            ) : (
                <span />
            )}
        </Grid>
    );
}
